import React from 'react';
import { Modal, Button } from 'antd';
import './index.scss'; // Assuming your styles are defined here
import { FormattedMessage, useIntl } from "react-intl";


// Import your assets
import WebPortalUserManual from '../../assets/document/WebPortalUserManual.png';
import MobileAppUserManual from '../../assets/document/MobileAppUserManual.png';
import MobileAppInstallationGuide from '../../assets/document/MobileAppInstallationGuide.png';
import LocationTagInstallationGuide from '../../assets/document/LocationTagInstallationGuide.png';
import linkIcon from '../../assets/document/link_icon.png';
import JTLogo from '../../assets/document/JT_Logo.png';

interface UsefulDocumentsProps {
  visible: boolean;
  onCancel: () => void;
}

// Define the structure for a download link
interface DownloadLink {
  text: string; // e.g., "简体中文", "English", "日本語"
  fileName: string; // e.g., "JTI_WebPortal_UserManual_CN.docx" - now includes the full file name with extension
}

// Define the structure for a document item
interface DocumentItem {
  image: string; // Path to the document's image
  title: string; // Display title of the document
  downloadLinks: DownloadLink[]; // Array of available download links
}

const UsefulDocumentsModal: React.FC<UsefulDocumentsProps> = ({
  visible,
  onCancel,
}) => {
  // Array to hold all document information, updated with the new file list and sorted by file name prefix
  const documents: DocumentItem[] = [
    {
      image: LocationTagInstallationGuide, // Changed to LocationTagInstallationGuide as requested
      title: 'Application Form NFC Location Tag Additional Issuance (China)',
      downloadLinks: [
        { text: 'English', fileName: '1. ApplicationForm_NFCLocationTag_AdditionalIssuance_China.docx' },
      ],
    },
    {
      image: LocationTagInstallationGuide,
      title: 'Installation Guide Location Tag (China)',
      downloadLinks: [
        { text: 'English', fileName: '2. Installation Guide Location Tag_EN.pdf' },
        { text: '简体中文', fileName: '2. Installation Guide Location Tag_CN.pdf' },
      ],
    },
    {
      image: MobileAppInstallationGuide,
      title: 'Installation Guide Mobile App (China)',
      downloadLinks: [
        { text: 'English', fileName: '3. Installation Guide Mobile App_EN.pdf' },
        { text: '简体中文', fileName: '3. Installation Guide Mobile App_CN.pdf' },
      ],
    },
    {
      image: MobileAppUserManual, // Reusing existing image for Mobile App User Manual
      title: 'User Manual Mobile App (China)',
      downloadLinks: [
        { text: 'English', fileName: '4. UserManual_Mobile_App_China_EN.pdf' },
        { text: '简体中文', fileName: '4. UserManual_Mobile_App_China_CN.pdf' },
      ],
    },
    {
      image: MobileAppUserManual, // Reusing image for Mobile App User Manual (Non-China)
      title: 'User Manual Mobile Portal (Non-China)',
      downloadLinks: [
        { text: 'English', fileName: '5. UserManual_MobilePortal_Non-China_EN.pdf' },
        { text: '日本語', fileName: '5. UserManual_MobilePortal_Non-China_JP.pdf' },
        { text: '简体中文', fileName: '5. UserManual_MobilePortal_Non-China_CN.pdf' },
      ],
    },
    {
      image: WebPortalUserManual, // Reusing existing image for Web Portal
      title: 'User Manual Web Portal (Non-China)',
      downloadLinks: [
        { text: 'English', fileName: '6. UserManual_WebPortal_EN.docx' },
        { text: '日本語', fileName: '6. UserManual_WebPortal_JP.docx' },
      ],
    },
  ];

  // Function to handle the download of a document
  const handleDownload = (fullFileName: string) => {
    const link = document.createElement('a');
    // The link.href now uses the fullFileName directly, including its extension
    link.href = `/download/${fullFileName}`;
    // The link.download also uses the fullFileName for the downloaded file name
    link.download = fullFileName;
    link.style.display = 'none'; // Hide the element

    document.body.appendChild(link); // Append to body to make it clickable
    link.click(); // Programmatically click the link to trigger download

    document.body.removeChild(link); // Clean up: remove the link after clicking
  };

  return (
    <Modal
      title=""
      centered
      open={visible}
      onOk={onCancel}
      onCancel={onCancel}
      destroyOnClose={true}
      width="90vw"
      footer={[
        <Button type="primary" onClick={onCancel} key="cancel">
          Cancel
        </Button>,
      ]}
      getContainer={false}
    >
      <div className="download_document_container">
        <div className="JTLogo_item">
          <img src={JTLogo} alt="" />
          <div className="logo_text"><FormattedMessage id="useful.documents.title"></FormattedMessage></div>
          <div></div>
        </div>

        <div className="useful_links">
          <img className="useful_links_img" src={linkIcon} alt="Link Icon" />
          <div>Useful Links</div>
        </div>

        {/* Dynamically render document sections using the 'documents' array */}
        {documents.map((doc, index) => (
          <div className="download_document" key={index}>
            <img className="logo" src={doc.image} alt={doc.title} />
            <div>
              <div className="title">{doc.title}</div>
              <div className="download_btn_item">
                {/* Map over the downloadLinks for each document */}
                {doc.downloadLinks.map((link, linkIndex) => (
                  <div
                    className="download_btn"
                    onClick={() => handleDownload(link.fileName)}
                    key={linkIndex}
                  >
                    <div className="download_text">{link.text}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default UsefulDocumentsModal;
